<template>
  <g id="Fuel" v-on:click="changeSeverity('rearFuel')" :class="severityClass">
    <rect
      class="cls-471"
      x="56.3"
      y="220.5"
      width="9.39"
      height="6.12"
      rx="1.16"
      ry="1.16"
    />
    <g>
      <path
        class="cls-315"
        d="M82.4,234.68c0,.48-.02,1.01-.07,1.6-.32,4.04-3.89,11.94-10.54,16.07-2.63,1.63-6.59,2.57-10.85,2.58h-.26c-4.27,0-8.22-.95-10.85-2.58-6.65-4.13-10.22-12.03-10.54-16.07-.05-.6-.07-1.12-.07-1.6,0-3.44,1.13-6.12,6.76-8.86,8.17-3.97,21.47-3.97,29.64,0,5.63,2.74,6.77,5.42,6.77,8.86Z"
      />
      <path
        class="cls-317"
        d="M46.07,225.86c8.13-3.95,21.37-3.95,29.5,0,5.61,2.72,6.73,5.39,6.73,8.82h0c0,.48-.02,1-.07,1.6-.32,4.04-3.89,11.93-10.52,16.04-2.61,1.62-6.54,2.55-10.77,2.56,0,0-.25,0-.26,0-4.23,0-8.16-.94-10.77-2.56-6.63-4.11-10.2-12-10.52-16.04-.05-.6-.07-1.12-.07-1.6,0-3.43,1.13-6.1,6.73-8.82Z"
      />
      <path
        class="cls-334"
        d="M46.14,225.9c8.09-3.93,21.26-3.93,29.35,0,5.58,2.71,6.7,5.36,6.7,8.78h0c0,.48-.02,1-.07,1.6-.32,4.04-3.89,11.92-10.49,16.01-2.59,1.61-6.49,2.53-10.69,2.54,0,0-.25,0-.26,0-4.2,0-8.1-.93-10.69-2.54-6.6-4.09-10.18-11.97-10.49-16.01-.05-.6-.07-1.12-.07-1.6,0-3.42,1.12-6.07,6.7-8.78Z"
      />
      <path
        class="cls-335"
        d="M46.21,225.93c8.05-3.91,21.16-3.91,29.21,0,5.56,2.7,6.67,5.34,6.67,8.75h0c0,.48-.02,1-.07,1.6-.32,4.04-3.9,11.9-10.47,15.98-2.57,1.6-6.44,2.52-10.61,2.52,0,0-.25,0-.26,0-4.17,0-8.04-.92-10.61-2.52-6.57-4.08-10.15-11.94-10.47-15.98-.05-.59-.07-1.12-.07-1.6,0-3.41,1.11-6.05,6.67-8.75Z"
      />
      <path
        class="cls-306"
        d="M46.28,225.97c8.01-3.89,21.06-3.89,29.07,0,5.53,2.69,6.64,5.31,6.64,8.71h0c0,.48-.02,1-.07,1.59-.32,4.04-3.9,11.89-10.45,15.95-2.55,1.58-6.4,2.5-10.53,2.5-.01,0-.24,0-.26,0-4.13,0-7.98-.92-10.53-2.5-6.55-4.06-10.13-11.91-10.45-15.95-.05-.59-.07-1.12-.07-1.59,0-3.4,1.11-6.02,6.64-8.71Z"
      />
      <path
        class="cls-228"
        d="M46.35,226.01c7.97-3.87,20.95-3.87,28.92,0,5.51,2.68,6.61,5.29,6.61,8.68h0c0,.48-.02,1-.07,1.59-.32,4.03-3.9,11.87-10.43,15.92-2.54,1.57-6.35,2.48-10.45,2.48-.02,0-.24,0-.26,0-4.1,0-7.92-.91-10.45-2.48-6.52-4.05-10.11-11.89-10.43-15.92-.05-.59-.07-1.11-.07-1.59,0-3.39,1.1-6,6.61-8.67Z"
      />
      <path
        class="cls-224"
        d="M46.43,226.04c7.93-3.85,20.85-3.85,28.78,0,5.48,2.66,6.58,5.26,6.58,8.64h0c0,.48-.02,1-.07,1.59-.32,4.03-3.91,11.86-10.4,15.89-2.52,1.56-6.3,2.46-10.36,2.46-.02,0-.24,0-.25,0-4.07,0-7.85-.9-10.37-2.46-6.5-4.03-10.09-11.86-10.4-15.89-.05-.59-.07-1.11-.07-1.59,0-3.38,1.1-5.98,6.58-8.64Z"
      />
      <path
        class="cls-221"
        d="M46.5,226.08c7.89-3.83,20.74-3.83,28.63,0,5.46,2.65,6.55,5.23,6.55,8.6h0c0,.48-.02,1-.07,1.59-.32,4.03-3.91,11.84-10.38,15.86-2.5,1.55-6.26,2.44-10.28,2.44-.02,0-.23,0-.25,0-4.03,0-7.79-.9-10.29-2.44-6.47-4.02-10.06-11.83-10.38-15.86-.05-.59-.07-1.11-.07-1.59,0-3.37,1.09-5.95,6.55-8.6Z"
      />
      <path
        class="cls-222"
        d="M46.57,226.12c7.85-3.81,20.64-3.81,28.49,0,5.43,2.64,6.52,5.21,6.52,8.57h0c0,.48-.02,1-.07,1.59-.32,4.03-3.91,11.83-10.36,15.83-2.48,1.54-6.21,2.42-10.2,2.43-.03,0-.23,0-.25,0-4,0-7.73-.89-10.21-2.43-6.45-4-10.04-11.8-10.36-15.83-.05-.59-.07-1.11-.07-1.59,0-3.36,1.08-5.93,6.52-8.57Z"
      />
      <path
        class="cls-328"
        d="M46.64,226.15c7.81-3.79,20.54-3.79,28.35,0,5.41,2.63,6.49,5.18,6.49,8.53h0c0,.48-.02,.99-.07,1.58-.32,4.03-3.91,11.82-10.34,15.8-2.46,1.52-6.16,2.4-10.12,2.41-.03,0-.23,0-.25,0-3.97,0-7.67-.88-10.13-2.41-6.42-3.98-10.02-11.77-10.34-15.8-.05-.59-.07-1.11-.07-1.58,0-3.35,1.08-5.9,6.48-8.53Z"
      />
      <path
        class="cls-325"
        d="M46.71,226.19c7.77-3.77,20.43-3.77,28.2,0,5.38,2.61,6.46,5.15,6.46,8.49h0c0,.48-.02,.99-.07,1.58-.32,4.03-3.92,11.8-10.31,15.77-2.44,1.51-6.11,2.38-10.04,2.39-.03,0-.22,0-.25,0-3.93,0-7.61-.87-10.05-2.39-6.4-3.97-10-11.74-10.31-15.77-.05-.59-.07-1.11-.07-1.58,0-3.34,1.07-5.88,6.45-8.49Z"
      />
      <path
        class="cls-323"
        d="M46.79,226.23c7.73-3.75,20.33-3.75,28.06,0,5.36,2.6,6.42,5.13,6.42,8.46h0c0,.47-.02,.99-.07,1.58-.32,4.03-3.92,11.79-10.29,15.74-2.42,1.5-6.07,2.36-9.96,2.37-.04,0-.22,0-.25,0-3.9,0-7.55-.87-9.97-2.37-6.37-3.95-9.97-11.72-10.29-15.74-.05-.59-.07-1.11-.07-1.58,0-3.33,1.07-5.85,6.42-8.46Z"
      />
      <path
        class="cls-343"
        d="M46.86,226.26c7.69-3.73,20.23-3.73,27.91,0,5.33,2.59,6.39,5.1,6.39,8.42h0c0,.47-.02,.99-.07,1.58-.32,4.02-3.92,11.77-10.27,15.71-2.4,1.49-6.02,2.34-9.88,2.35-.04,0-.21,0-.25,0-3.87,0-7.49-.86-9.89-2.35-6.35-3.94-9.95-11.69-10.27-15.71-.05-.59-.07-1.1-.07-1.58,0-3.32,1.06-5.83,6.39-8.42Z"
      />
      <path
        class="cls-342"
        d="M46.93,226.3c7.65-3.71,20.12-3.71,27.77,0,5.31,2.58,6.36,5.08,6.36,8.38h0c0,.47-.02,.99-.07,1.58-.32,4.02-3.93,11.76-10.25,15.68-2.38,1.48-5.97,2.32-9.8,2.33-.04,0-.21,0-.25,0-3.83,0-7.43-.85-9.81-2.33-6.32-3.92-9.93-11.66-10.25-15.68-.05-.59-.07-1.1-.07-1.58,0-3.31,1.05-5.8,6.36-8.38Z"
      />
      <path
        class="cls-338"
        d="M47,226.34c7.61-3.69,20.02-3.69,27.63,0,5.28,2.57,6.33,5.05,6.33,8.35h0c0,.47-.02,.99-.07,1.57-.32,4.02-3.93,11.75-10.22,15.65-2.36,1.46-5.93,2.31-9.72,2.31-.04,0-.21,0-.25,0-3.8,0-7.37-.85-9.73-2.31-6.3-3.91-9.91-11.63-10.22-15.65-.05-.59-.07-1.1-.07-1.57,0-3.3,1.05-5.78,6.33-8.35Z"
      />
      <path
        class="cls-367"
        d="M47.07,226.37c7.56-3.67,19.92-3.67,27.48,0,5.26,2.55,6.3,5.02,6.3,8.31h0c0,.47-.02,.99-.07,1.57-.32,4.02-3.93,11.73-10.2,15.62-2.34,1.45-5.88,2.29-9.64,2.29-.05,0-.2,0-.25,0-3.77,0-7.31-.84-9.65-2.29-6.27-3.89-9.88-11.6-10.2-15.62-.05-.59-.07-1.1-.07-1.57,0-3.29,1.04-5.76,6.3-8.31Z"
      />
      <path
        class="cls-390"
        d="M47.15,226.41c7.52-3.65,19.81-3.66,27.34,0,5.23,2.54,6.27,5,6.27,8.27h0c0,.47-.02,.99-.07,1.57-.32,4.02-3.93,11.72-10.18,15.59-2.32,1.44-5.83,2.27-9.56,2.27-.05,0-.2,0-.25,0-3.73,0-7.25-.83-9.57-2.27-6.24-3.87-9.86-11.57-10.18-15.59-.05-.59-.07-1.1-.07-1.57,0-3.28,1.04-5.73,6.27-8.27Z"
      />
      <path
        class="cls-372"
        d="M47.22,226.44c7.48-3.64,19.71-3.64,27.2,0,5.21,2.53,6.24,4.97,6.24,8.24h0c0,.47-.02,.98-.07,1.57-.32,4.02-3.94,11.7-10.16,15.56-2.3,1.43-5.79,2.25-9.48,2.25-.05,0-.2,0-.25,0-3.7,0-7.19-.83-9.49-2.25-6.22-3.86-9.84-11.54-10.16-15.56-.05-.58-.07-1.1-.07-1.57,0-3.27,1.03-5.71,6.24-8.24Z"
      />
      <path
        class="cls-369"
        d="M47.29,226.48c7.44-3.62,19.61-3.62,27.05,0,5.18,2.52,6.21,4.94,6.21,8.2h0c0,.47-.02,.98-.07,1.57-.32,4.02-3.94,11.69-10.13,15.53-2.28,1.42-5.74,2.23-9.4,2.23-.06,0-.19,0-.25,0-3.67,0-7.12-.82-9.41-2.23-6.19-3.84-9.82-11.52-10.13-15.53-.05-.58-.07-1.1-.07-1.57,0-3.26,1.02-5.68,6.21-8.2Z"
      />
      <path
        class="cls-411"
        d="M47.36,226.52c7.4-3.6,19.5-3.6,26.91,0,5.16,2.51,6.18,4.92,6.18,8.16h0c0,.47-.02,.98-.07,1.56-.32,4.01-3.94,11.67-10.11,15.5-2.26,1.4-5.69,2.21-9.32,2.21-.06,0-.19,0-.25,0-3.63,0-7.06-.81-9.33-2.21-6.17-3.83-9.8-11.49-10.11-15.5-.05-.58-.07-1.1-.07-1.56,0-3.25,1.02-5.66,6.18-8.16Z"
      />
      <path
        class="cls-357"
        d="M47.43,226.55c7.36-3.58,19.4-3.58,26.76,0,5.13,2.49,6.15,4.89,6.15,8.13h0c0,.47-.02,.98-.07,1.56-.32,4.01-3.95,11.66-10.09,15.47-2.24,1.39-5.64,2.19-9.24,2.2-.06,0-.19,0-.25,0-3.6,0-7-.8-9.25-2.19-6.14-3.81-9.77-11.46-10.09-15.47-.05-.58-.07-1.09-.07-1.56,0-3.24,1.01-5.63,6.14-8.13Z"
      />
      <path
        class="cls-358"
        d="M47.51,226.59c7.32-3.56,19.3-3.56,26.62,0,5.11,2.48,6.12,4.86,6.12,8.09h0c0,.47-.02,.98-.07,1.56-.32,4.01-3.95,11.65-10.07,15.44-2.22,1.38-5.6,2.17-9.16,2.18-.07,0-.18,0-.25,0-3.57,0-6.94-.8-9.16-2.18-6.12-3.8-9.75-11.43-10.07-15.44-.05-.58-.07-1.09-.07-1.56,0-3.23,1.01-5.61,6.11-8.09Z"
      />
      <path
        class="cls-389"
        d="M47.58,226.63c7.28-3.54,19.19-3.54,26.48,0,5.08,2.47,6.08,4.84,6.08,8.05h0c0,.47-.02,.98-.07,1.56-.32,4.01-3.95,11.63-10.04,15.41-2.2,1.37-5.55,2.15-9.08,2.16-.07,0-.18,0-.25,0-3.53,0-6.88-.79-9.08-2.16-6.09-3.78-9.73-11.4-10.04-15.41-.05-.58-.07-1.09-.07-1.56,0-3.22,1-5.59,6.08-8.05Z"
      />
      <path
        class="cls-387"
        d="M47.65,226.66c7.24-3.52,19.09-3.52,26.33,0,5.06,2.46,6.05,4.81,6.05,8.02h0c0,.47-.02,.98-.07,1.56-.32,4.01-3.95,11.62-10.02,15.38-2.18,1.35-5.5,2.13-9,2.14-.07,0-.18,0-.25,0-3.5,0-6.82-.78-9-2.14-6.07-3.76-9.71-11.37-10.02-15.38-.05-.58-.07-1.09-.07-1.56,0-3.21,.99-5.56,6.05-8.02Z"
      />
      <path
        class="cls-263"
        d="M47.72,226.7c7.2-3.5,18.99-3.5,26.19,0,5.04,2.45,6.02,4.79,6.02,7.98h0c0,.47-.02,.97-.07,1.55-.32,4.01-3.96,11.6-10,15.35-2.16,1.34-5.46,2.11-8.92,2.12-.08,0-.17,0-.25,0-3.47,0-6.76-.78-8.92-2.12-6.04-3.75-9.68-11.35-10-15.35-.05-.58-.07-1.09-.07-1.55,0-3.2,.99-5.54,6.02-7.98Z"
      />
      <path
        class="cls-264"
        d="M47.79,226.74c7.16-3.48,18.88-3.48,26.04,0,5.01,2.43,5.99,4.76,5.99,7.95h0c0,.47-.02,.97-.07,1.55-.32,4.01-3.96,11.59-9.98,15.32-2.14,1.33-5.41,2.1-8.84,2.1-.08,0-.17,0-.25,0-3.43,0-6.7-.77-8.84-2.1-6.02-3.73-9.66-11.32-9.98-15.32-.05-.58-.07-1.09-.07-1.55,0-3.19,.98-5.51,5.99-7.94Z"
      />
      <path
        class="cls-375"
        d="M79.73,234.68c0,.46-.02,.97-.07,1.55-.32,4-3.96,11.58-9.95,15.29-2.12,1.32-5.36,2.08-8.76,2.08-.08,0-.17,0-.25,0-3.4,0-6.64-.76-8.76-2.08-5.99-3.72-9.64-11.29-9.95-15.29-.05-.58-.07-1.09-.07-1.55,0-3.18,.98-5.49,5.96-7.91,7.12-3.46,18.78-3.46,25.9,0,4.99,2.42,5.96,4.73,5.96,7.91h0Z"
      />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
